(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const PV = window.PV || {};

  // ---------- money ----------
  const money = (cents) => {
    const fmt = PV.moneyFormat || "${{amount}}";
    const n = (cents / 100);
    const withDec = n.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = Math.round(n).toLocaleString("es-MX");
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace(/,/g, "_").replace(".", ",").replace(/_/g, "."))
      .replace(/\{\{\s*amount\s*\}\}/, withDec)
      .replace(/<[^>]+>/g, "");
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  // ---------- cart ----------
  let cart = null;
  const getCart = () => fetch(PV.routes.cart, { headers: { Accept: "application/json" } }).then((r) => r.json());

  function renderCart(bump) {
    if (!cart) return;
    const badge = $(".cart-count");
    if (badge) {
      badge.hidden = !cart.item_count;
      badge.textContent = cart.item_count;
      if (bump) { badge.classList.remove("pop"); void badge.offsetWidth; badge.classList.add("pop"); }
    }
    const box = $("[data-cart-items]");
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<div class="empty"><span class="hand">tu canasta está vacía</span>Agrega un pan rico y nutritivo.</div>';
    } else {
      box.innerHTML = cart.items.map((i) => {
        const img = i.image ? i.image + (i.image.includes("?") ? "&" : "?") + "width=200" : "";
        const variant = i.product_has_only_default_variant ? "" : `<small>${esc(i.variant_title || "")}</small>`;
        // SUPR FIX: show the subscription plan (e.g. "Envío mensual") on subscription lines in the drawer
        const plan = i.selling_plan_allocation ? `<small>${esc(i.selling_plan_allocation.selling_plan.name)}</small>` : "";
        return `<div class="ci">${img ? `<img src="${img}" alt="">` : "<span></span>"}<div><h5>${esc(i.product_title)}</h5>${variant}${plan}
          <div class="q"><button data-line="${esc(i.key)}" data-qty-to="${i.quantity - 1}" aria-label="Menos">−</button><span>${i.quantity}</span><button data-line="${esc(i.key)}" data-qty-to="${i.quantity + 1}" aria-label="Más">+</button>
          <button class="rm" data-line="${esc(i.key)}" data-qty-to="0">quitar</button></div></div><b>${money(i.final_line_price)}</b></div>`;
      }).join("");
    }
    const tot = $("[data-cart-total]");
    if (tot) tot.textContent = money(cart.total_price);
    const pay = $("[data-checkout-link]");
    if (pay) pay.classList.toggle("disabled", !cart.item_count);
  }

  // SUPR FIX: accept the chosen subscription plan and send it to the cart
  async function addToCart(id, quantity = 1, sellingPlan) {
    const item = { id: +id, quantity: +quantity };
    if (sellingPlan) item.selling_plan = +sellingPlan; // empty = one-time purchase
    const r = await fetch(PV.routes.cartAdd, {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [item] }),
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || "No se pudo agregar");
    cart = await getCart();
    renderCart(true);
  }

  async function changeLine(key, quantity) {
    const r = await fetch(PV.routes.cartChange, {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    cart = await r.json();
    renderCart();
  }

  const openCart = () => document.body.classList.add("cart-open");
  const closeCart = () => document.body.classList.remove("cart-open");

  function waOrder() {
    if (!cart || !cart.items.length || !PV.wa) return;
    const lines = cart.items.map((i) => `• ${i.quantity} × ${i.product_title}${i.product_has_only_default_variant ? "" : " (" + i.variant_title + ")"} — ${money(i.final_line_price)}`);
    const note = cart.note ? `\n\nNota: ${cart.note}` : "";
    const msg = `¡Hola ${PV.shop}! 🍞 Quiero hacer este pedido:\n\n${lines.join("\n")}\n\nSubtotal: ${money(cart.total_price)}${note}\n\nMi ciudad / código postal: `;
    window.open(`https://wa.me/${PV.wa}?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
  }

  // ---------- product page ----------
  const section = $("[data-product-section]");
  if (section) {
    const data = JSON.parse($("[data-product-json]", section).textContent);
    const form = $(".product-form", section);
    const idInput = $("[data-variant-id]", section);
    const btn = $("[data-add-btn]", section);
    const main = $(".main-img", section);

    const selected = () => $$(".opts", section).map((g) => $(".opt.on", g)?.dataset.opt);
    const setMain = (src, mediaId) => {
      if (!main || !src) return;
      main.style.opacity = 0;
      setTimeout(() => { main.removeAttribute("srcset"); main.src = src; main.style.opacity = 1; }, 160);
      $$(".th", section).forEach((t) => t.classList.toggle("on", t.dataset.mediaId == mediaId));
    };
    function syncVariant() {
      const opts = selected();
      const v = data.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$(".opts", section).forEach((g, gi) => {
        $$(".opt", g).forEach((b) => {
          const trial = opts.slice(); trial[gi] = b.dataset.opt;
          const exists = data.variants.find((x) => x.options.every((o, i) => o === trial[i]));
          b.classList.toggle("na", !exists || !exists.available);
        });
      });
      if (!v) { btn.disabled = true; btn.textContent = "No disponible"; return; }
      idInput.value = v.id;
      $("[data-price]", section).textContent = v.price;
      const cmp = $("[data-compare]", section);
      if (cmp) { cmp.hidden = !v.compare; if (v.compare) cmp.textContent = v.compare; }
      btn.disabled = !v.available;
      btn.textContent = v.available ? "Agregar a la canasta" : "Agotado";
      const url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url);
      if (v.media) {
        const th = $(`.th[data-media-id="${v.media}"]`, section);
        if (th) setMain(th.dataset.src, v.media);
      }
    }
    if ($(".opts", section)) syncVariant();

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      btn.classList.add("loading");
      try {
        // SUPR FIX: read the subscription option the shopper picked in the Supr widget
        const planInput = $('[name="selling_plan"]', form) || $('[name="selling_plan"]', section);
        await addToCart(idInput.value, Math.max(1, parseInt($("[data-qty]", section).value) || 1), planInput && planInput.value);
        openCart();
      } catch (err) {
        alert(err.message);
      } finally { btn.classList.remove("loading"); }
    });

    section.addEventListener("click", (e) => {
      const t = e.target.closest("button");
      if (!t) return;
      if (t.matches(".opt")) {
        $$(".opt", t.closest(".opts")).forEach((o) => o.classList.toggle("on", o === t));
        syncVariant();
      } else if (t.matches("[data-q]")) {
        const inp = $("[data-qty]", section);
        inp.value = Math.max(1, (parseInt(inp.value) || 1) + +t.dataset.q);
      } else if (t.matches(".th")) {
        setMain(t.dataset.src, t.dataset.mediaId);
      }
    });
  }

  // ---------- global clicks ----------
  document.addEventListener("click", async (e) => {
    const t = e.target.closest("button,a");
    if (!t) return;
    if (t.matches("[data-open-cart]")) {
      if (!$("[data-drawer]")) return;
      e.preventDefault(); openCart();
      if (!cart) { cart = await getCart(); renderCart(); }
    } else if (t.matches("[data-close-cart]")) closeCart();
    else if (t.matches("[data-add]")) {
      e.preventDefault();
      t.classList.add("loading");
      try {
        await addToCart(t.dataset.add);
        t.classList.add("ok"); t.textContent = "✓ Listo";
        setTimeout(() => { t.classList.remove("ok"); t.textContent = "+ Agregar"; }, 1400);
      } catch (err) { alert(err.message); }
      t.classList.remove("loading");
    } else if (t.matches("[data-qty-to]")) {
      changeLine(t.dataset.line, Math.max(0, +t.dataset.qtyTo));
    } else if (t.matches("[data-wa-order]")) {
      e.preventDefault();
      if (!cart) cart = await getCart();
      waOrder();
    } else if (t.matches("[data-checkout-link]") && cart && !cart.item_count) {
      e.preventDefault();
    } else if (t.matches("[data-burger]")) document.body.classList.toggle("menu");
    else if (t.matches("[data-strip]")) {
      const tr = $("[data-strip-track]");
      tr.scrollBy({ left: +t.dataset.strip * tr.clientWidth * 0.8, behavior: "smooth" });
    } else if (t.matches("[data-filter]")) {
      const f = t.dataset.filter;
      $$("[data-filter]").forEach((c) => c.classList.toggle("on", c === t));
      $$("[data-group]").forEach((g) => (g.hidden = f !== "all" && g.dataset.group !== f));
      history.replaceState(null, "", f === "all" ? location.pathname + location.search : "#" + f);
    } else if (t.matches("[data-scope]")) {
      const s = t.dataset.scope;
      $$("[data-plan-filter] .chip").forEach((c) => c.classList.toggle("on", c === t));
      $$(".plan").forEach((p) => (p.hidden = s !== "all" && p.dataset.scope !== s));
    }
  });
  document.addEventListener("keydown", (e) => e.key === "Escape" && closeCart());

  // deep links like /collections/all#panes
  const h = decodeURIComponent(location.hash.slice(1));
  const chip = h && $(`[data-filter="${CSS.escape(h)}"]`);
  if (chip) chip.click();

  // reveal on scroll
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }), { rootMargin: "0px 0px -8% 0px" });
    $$(".reveal").forEach((el, i) => { el.style.transitionDelay = (i % 4) * 70 + "ms"; io.observe(el); });
  } else $$(".reveal").forEach((el) => el.classList.add("in"));

  // theme editor: show everything immediately
  if (window.Shopify && Shopify.designMode) {
    $$(".reveal").forEach((el) => el.classList.add("in"));
    document.addEventListener("shopify:section:load", () => $$(".reveal").forEach((el) => el.classList.add("in")));
  }

  // initial cart count
  getCart().then((c) => { cart = c; renderCart(); }).catch(() => {});
})();